import { AUTH_RECAPTCHA_FAILED_MESSAGE } from "./authRecaptchaConstants";

export function showAuthRecaptchaFailureAlert(addErrorAlert) {
  if (typeof addErrorAlert !== "function") {
    return;
  }

  addErrorAlert({ title: AUTH_RECAPTCHA_FAILED_MESSAGE });
}
